import React from 'react';
import PropTypes from 'prop-types';
import {
    View,
    Text,
    ActivityIndicator,
    Image,
    TouchableOpacity
} from 'react-native-web';
import Icon from 'react-native-vector-icons/dist/FontAwesome';
import FeatherIcon from 'react-native-vector-icons/dist/Feather';

// Configs
import GLOBAL from '../configs/config_global';
import { isNumber } from 'lodash';

export function Button(props) {
    const {
        text,
        loadingText,
        isLoading,
        image,
        textStyle,
        locked,
        textColor,
        backgroundColor,
        lockedBackgroundColor,
        onLayout,
        useFeather,
        style,
        onPress,
        imageSize,
        imageColor,
        imageNextToText
    } = props;

    const MyView = (locked || isLoading) ? View : TouchableOpacity;
    const IconComp = useFeather ? FeatherIcon : Icon;
    const extraBorder = style ? (style.borderWidth ? (style.borderWidth + 2) : 0) : 0;

    return(
        <MyView
            onPress={onPress}
            onLayout={onLayout}
            style={[{ alignSelf: 'stretch', borderRadius: 6, overflow: 'hidden' }].concat(style)}>
            <View style={[
                {
                    flexDirection: 'row', alignItems: 'center', justifyContent: 'center',
                    opacity: isLoading ? 0.5 : 1, borderRadius: 6,
                    backgroundColor: locked ? lockedBackgroundColor : (style?.backgroundColor || backgroundColor),
                    width: '100%', height: style ? ((style?.height && isNumber(style?.height)) ? style.height : 64) - extraBorder : (64 - extraBorder)
                }
            ]}>
                {/* Image Icon / Loading Indicator */}
                {
                    isLoading ?
                        <ActivityIndicator
                            color={textColor || textStyle?.color}
                            style={{ width: 16, height: 16, marginRight: text.trim() ? 10 : 0, marginLeft: text.trim() ? 15 : 0 }}
                        />
                        :
                        (
                            image ?
                                (
                                    (typeof image === 'string' && !image.startsWith('data:image/png')) ?
                                        <IconComp
                                            name={image}
                                            size={imageSize || 20}
                                            style={{ marginLeft: text.trim() ? 16 : 0 }}
                                            color={imageColor || textColor}
                                        />
                                        :
                                        <Image
                                            source={image}
                                            style={{ width: imageSize, height: imageSize, marginLeft: text.trim() ? 16 : 0 }}
                                            tintColor={imageColor}
                                            resizeMode={'contain'}
                                        />
                                )
                                :
                                null
                        )
                }

                {/* Text */}
                {
                    !!text.trim() &&
                    <Text style={[
                        { fontSize: 18, color: textColor, textAlign: 'center', fontWeight: 'bold', marginRight: !!image ? imageSize : 0 },
                        image ? (imageNextToText ? { marginLeft: 16 } : { flex: 1 }) : {},
                        textStyle || {}
                    ]}>
                        {loadingText ? (isLoading ? loadingText : text) : text}
                    </Text>
                }
            </View>
        </MyView>
    );
}

Button.propTypes = {
    text: PropTypes.string,
    loadingText: PropTypes.string,
    isLoading: PropTypes.bool,
    image: PropTypes.any,
    textStyle: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    locked: PropTypes.bool,
    lockedBackgroundColor: PropTypes.string,
    onLayout: PropTypes.func,
    useFeather: PropTypes.bool,
    style: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    textColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    onPress: PropTypes.func,
    pushText: PropTypes.bool,
    imageSize: PropTypes.number,
    imageColor: PropTypes.string,
    imageNextToText: PropTypes.bool
};

Button.defaultProps = {
    text: 'Button',
    loadingText: '',
    isLoading: false,
    image: '',
    textStyle: {},
    locked: false,
    lockedBackgroundColor: GLOBAL.COLOR.BASIC.NEUTRAL_STROKE,
    onLayout: () => {},
    useFeather: false,
    style: {},
    textColor: 'white',
    backgroundColor: GLOBAL.COLOR.MAIN,
    onPress: () => {},
    pushText: false,
    imageSize: 16,
    imageColor: 'white',
    imageNextToText: false
};
